import { Badge } from "../../primitives/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "../../primitives/tooltip";

interface V1TrialBadgeProps {
  /**
   * Hover text for the tagged field — explains how it maps onto the
   * Tharstern desktop UI. Tharstern labels its estimate Ref slots bare
   * ("Ref 1" … "Ref 10") with no friendly names, so the mapping is never
   * obvious from our field labels; the tooltip closes that gap. For a
   * `review`-tone field it also poses the open question we need answered.
   */
  mapping: string;
  /**
   * `trial` — a new structured v1-illustration field (amber).
   * `review` — a field flagged for likely removal pending a check (red).
   */
  tone?: "trial" | "review";
}

/**
 * Marks a delivery field as part of the v1-illustration trial and carries a
 * tooltip spelling out the Tharstern-field mapping. Used on the
 * DeliverySection.
 */
export function V1TrialBadge({ mapping, tone = "trial" }: V1TrialBadgeProps) {
  const isReview = tone === "review";
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge
          variant={isReview ? "error" : "warning"}
          className="cursor-help align-middle font-normal"
        >
          {isReview ? "v1 · under review" : "v1 trial"}
        </Badge>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs text-pretty">
        {mapping}
      </TooltipContent>
    </Tooltip>
  );
}
